























































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import dayjs from "dayjs";
import { dateNameMonth, dateYear } from "@/shared/filters";

@Component({
  filters: { dateNameMonth, dateYear },
})
export default class SelectYearMounth extends Vue {
  @Prop({ default: null }) readonly value!: string | null;

  date: string | null = null;
  menu = false;

  @Watch("date")
  onChange() {
    if (this.date !== this.value) {
      this.$emit("input", this.date);
    }
  }

  @Watch("value")
  onChangeValue() {
    if (this.value !== this.date) {
      this.date = this.value;
    }
  }

  mounted() {
    this.date = this.value || dayjs().format("YYYY-MM");
  }

  prev() {
    if (this.date) {
      this.date = dayjs(this.date)
        .subtract(1, "month")
        .format("YYYY-MM");
    }
  }

  prox() {
    if (this.date) {
      this.date = dayjs(this.date)
        .add(1, "month")
        .format("YYYY-MM");
    }
  }

  alteraData(val: any) {
    (this.$refs.menu as any).save(val);
  }
}
